import React, { useContext } from 'react';
import ModalModule from '../modal';
import Utils from '../utils';
import PlanChangeConfirmationModal from './PlanChangeConfirmationModal.component';
import UpgradePlanOrdersAndProductsContent from './UpgradePlanOrdersAndProductsContent.component';
import UpgradePlanContent from './UpgradePlanContent.component';
import PlanPriceComparison from './PlanPriceComparison.component';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { Session } = Utils;

const UpgradePlanModal = ({ modalId, data }) => {
	const {
		upgradePlan = {},
		onUpgradePlanCallback,
		segmentTrackingCallback,
		triggerFeature,
		upgradePrompt,
	} = data;
	const { Name, Price, PlanId } = upgradePlan;
	const { brandName } = Session.getBrand();

	let header;

	if (triggerFeature === 'Orders' || triggerFeature === 'Products') {
		header = `Access ${brandName} ${triggerFeature}`;
	} else if (triggerFeature === 'FeeDetails') {
		header = `Change to the ${Name} Plan`;
	} else {
		header = `Upgrade to the ${Name} Plan`;
	}

	const { closeModal, showModal } = useContext(ModalContext);

	const primaryButton = {
		type: ModalButtonActionType.Confirm,
		text: 'Change Now',
		onClick: () => {
			setTimeout(() => {
				if (segmentTrackingCallback) {
					segmentTrackingCallback('changeNow');
				}

				showModal({
					component: PlanChangeConfirmationModal,
					data: {
						newPlanPrice: Price,
						newPlanName: Name,
						newPlanId: PlanId,
						isUpgrade: true,
						upgradePrompt,
						onUpgradePlanCallback,
					},
				});

				closeModal(modalId, ModalButtonActionType.Confirm);
			}, 500);
		},
		dataqa: 'upgrade-plan-change-now-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'Dismiss',
		onClick: () => {
			segmentTrackingCallback('dismiss');
			closeModal(modalId, ModalButtonActionType.Cancel);
		},
		dataqa: 'upgrade-plan-dismiss-button',
	};

	const modalSize = ['FeeDetails', 'Orders', 'Products'].includes(triggerFeature)
		? 'medium'
		: 'small';

	const getModalContent = () => {
		const contentMap = {
			Orders: <UpgradePlanOrdersAndProductsContent data={data} />,
			Products: <UpgradePlanOrdersAndProductsContent data={data} />,
			FeeDetails: <PlanPriceComparison data={data} />,
		};

		return contentMap[triggerFeature] || <UpgradePlanContent data={data} />;
	};

	return (
		<div>
			<Modal
				modalId={modalId}
				className={`subscription-plan upgrade-plan-modal ${
					triggerFeature === 'FeeDetails' ? 'fee-details' : ''
				}`}
				header={header}
				primaryButton={primaryButton}
				secondaryButton={secondaryButton}
				size={modalSize}
			>
				<div className="body">{getModalContent()}</div>
			</Modal>
		</div>
	);
};

export default UpgradePlanModal;
